import { Component, output, signal } from '@angular/core';
import { RidButton } from '../rid-button/rid-button';
import { RidRatingStar } from '../rid-rating-star/rid-rating-star';

@Component({
  selector: 'rid-rating-modal',
  imports: [RidRatingStar, RidButton],
  templateUrl: './rid-rating-modal.html',
  host: {
    class: 'absolute',
    'animate.enter': 'anim-pop-in',
    'animate.leave': 'anim-pop-out',
  },
})
export class RidRatingModal {
  rating = signal<number | undefined>(undefined);

  canceled = output<void>();
  continued = output<void>();

  rate(rating: number) {
    this.rating.set(rating);
  }
}
